<template>
  <v-dialog
    v-if="localFilter"
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xs"
    persistent
    scrollable
    :max-width="`${width}px`"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon flat @click="$emit('close')">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-toolbar-title>FILTER {{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          :color="!filterOn ? '' : 'orange'"
          icon
          flat
          @click="toggleFilter"
        >
          <v-icon>{{ filterOn ? "cancel" : "check_circle" }} </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text style="height: 1000px">
        <v-form>
          <slot name="filter-content" :filter="localFilter"> </slot>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from "lodash";
import c from "@/constants";

export default {
  name: "pg-form-filter",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    width: {
      type: Number,
      default: 500
    },
    filterOn: {
      type: Boolean,
      default: false
    },
    filter: {
      type: Object,
      default: null
    },
    source: {
      type: Array,
      default: new Array()
    },
    sourceOriginal: {
      type: Array,
      default: new Array()
    }
  },
  data() {
    return {
      localFilter: null,
      watcherHelper: null
    };
  },
  watch: {
    sourceOriginal(val) {
      if (val.length) this.localFilter = this.buildFilter();
    },
    dialog(val) {
      if (val && !this.filterOn) {
        this.localFilter = this.buildFilter();
      }
    },
    source(val) {
      if (val.length) {
        if (
          !this.localFilter ||
          _.isEqual(this.sourceOriginal, this.applyFilter())
        ) {
          this.localFilter = this.buildFilter();
        }
      }
    },
    localFilter: {
      deep: true,
      handler(val) {
        if (val) {
          if (this.filterOn) {
            if (
              !_.isEqual(this.sourceOriginal, this.applyFilter()) ||
              !_.isEqual(this.watcherHelper, val)
            )
              this.$emit("filtered", this.applyFilter());
          }
          this.watcherHelper = _.cloneDeep(val);
        }
      }
    }
  },
  methods: {
    toggleFilter() {
      if (!this.filterOn) this.$emit("filtered", this.applyFilter());
      this.$emit("toggle");
    },
    buildFilter() {
      let filter = _.cloneDeep(this.filter);
      if (this.localFilter && this.filterOn)
        filter = _.cloneDeep(this.localFilter);
      _.map(filter.format, (format, field) => {
        if (format == c.FORMAT.number) {
          // set max min of number
          let max = _.maxBy(this.sourceOriginal, o => {
            return parseInt(o[field]);
          })[field];
          let min = _.minBy(this.sourceOriginal, o => {
            return parseInt(o[field]);
          })[field];
          filter[field] = [parseInt(min), parseInt(max)];
          filter.field[field] = _.cloneDeep(filter[field]);
        } else if (format == c.FORMAT.date || format == c.FORMAT.datetime) {
          // set max min of date & datetime
          let DATE_FORMAT = "YYYY-MM-DD HH:mm:ss";
          if (format == c.FORMAT.date) DATE_FORMAT = "YYYY-MM-DD";
          // then check
          let validData = this.sourceOriginal.filter(s => {
            return this.$moment(s[field], DATE_FORMAT).isValid();
          });
          let max = _.maxBy(validData, field)[field];
          let min = _.minBy(validData, field)[field];
          filter[field] = [min, max];
          filter.field[field] = [min, max];
        } else if (format == c.FORMAT.text || format == c.FORMAT.text_options) {
          let bool = false;
          if (!filter.field[field]) {
            bool = true;
          } else if (!filter.field[field].length) {
            bool = true;
          }
          if (bool) {
            filter.field[field] = _(this.sourceOriginal)
              .groupBy(field)
              .map((val, i) => {
                if (i) return i;
              })
              .remove(undefined)
              .value();
          }
        }
      });
      return filter;
    },
    applyFilter() {
      return this.sourceOriginal.filter(data => {
        let bool = true;
        _.map(this.localFilter.format, (format, field) => {
          let tf = this.localFilter[field];
          let td = data[field];
          if (format == c.FORMAT.options || format == c.FORMAT.text_options) {
            if (tf.length) {
              if (!tf.includes(td)) bool = false;
            }
          } else if (format == c.FORMAT.options_group) {
            if (tf.length) {
              let group = this.localFilter.options_group[field];
              let found = false;
              for (let i = 0; i < data[group].length; i++) {
                if (tf.includes(data[group][i][field])) found = true;
              }
              if (!found) bool = false;
            }
          } else if (format == c.FORMAT.text) {
            if (tf) {
              if (!(td.toUpperCase().indexOf(tf.toUpperCase()) > -1)) {
                bool = false;
              }
            }
          } else if (format == c.FORMAT.number) {
            if (!(parseInt(td) >= tf[0] && parseInt(td) <= tf[1])) {
              bool = false;
            }
          } else if (format == c.FORMAT.datetime || format == c.FORMAT.date) {
            if (
              !(
                Date.parse(td) >= Date.parse(tf[0]) &&
                Date.parse(td) <= Date.parse(tf[1])
              )
            ) {
              bool = false;
            }
          }
        });
        return bool;
      });
    }
  }
};
</script>
